:host {
  --rounded-value: #{map-get($spacing-sizes, 2)};
  @include reset-host;
}

:host {
  position: relative;
}

:host .video-thumbnail {
  position: relative;

  width: 100%;
  overflow: clip;

  border: 0;
  border-radius: var(--rounded-value);
  cursor: pointer;

  &:after {
    @include cover;
    background: rgba(0, 0, 0, 0.2);

    content: '';
  }

  &.has-square-ratio {
    aspect-ratio: 1 / 1;
  }

  &.has-landscape-ratio {
    aspect-ratio: 16 / 9;
  }

  &.has-portrait-ratio {
    aspect-ratio: 3 / 5;
  }
}

:host .play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;

  color: $white;
  font-size: rem(85);

  transform: translate(-50%, -50%);

  pointer-events: none;
}

:host .text-wrapper {
  line-height: 1.4;
}

// size variants
:host .video-block {
  &.is-default-size,
  &.is-standout-size {
    .text-wrapper {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;

      width: 100%;

      color: $white;

      &:before {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: -1;

        width: 100%;
        height: 150%;

        background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
        border-bottom-right-radius: var(--rounded-value);
        border-bottom-left-radius: var(--rounded-value);

        content: '';
      }
    }
  }

  // default
  &.is-default-size {
    .text-wrapper {
      padding: map-get($spacing-sizes, 2);
      padding-right: 20%;

      line-height: 1.2;
    }

    .title {
      margin-bottom: rem(4);

      font-weight: $fw-bold;
      font-size: $fs-lg;
    }
  }

  // standout
  &.is-standout-size {
    --rounded-value: #{map-get($spacing-sizes, 1)};

    .text-wrapper {
      padding: 0 20% 20%;

      line-height: 1.4;
      text-align: center;

      pointer-events: none;

      @include mq('max', 'md') {
        padding: 0 10% 10%;
      }
    }

    .title {
      margin-bottom: rem(15);

      font-weight: $fw-regular;
      font-size: rem(36);
      line-height: 1.2;

      @include mq('max', 'md') {
        font-size: rem(30);
      }
    }
  }

  // thumbnail
  &.is-thumbnail-size {
    --rounded-value: #{map-get($spacing-sizes, 1)};

    display: flex;
    gap: map-get($spacing-sizes, 2);
    align-items: center;

    @include mq('max', 'md') {
      flex-direction: column;
      max-width: rem(154);
    }

    .video-thumbnail {
      max-width: rem(150);
    }

    .play-button {
      font-size: rem(48);
    }

    .text-wrapper {
      bottom: 10%;
    }

    .text {
      font-size: $fs-sm;
    }

    .video-thumbnail.has-square-ratio {
      width: rem(150);
      height: rem(150);
    }

    .video-thumbnail.has-portrait-ratio {
      width: rem(154);
      height: rem(270);
    }
  }
}
